import PropTypes from 'prop-types';
import React from 'react';

export default class StyleGuide extends React.Component {
  render() {
    return (
      <div>
        <div>
          <h2>Buttons</h2>
          <div className="d-flex justify-content-between">
            <button type="button" className="btn btn-primary">Primary</button>
            <button type="button" className="btn btn-secondary">Secondary</button>
            <button type="button" className="btn btn-success">Success</button>
            <button type="button" className="btn btn-danger">Danger</button>
            <button type="button" className="btn btn-warning">Warning</button>
            <button type="button" className="btn btn-info">Info</button>
            <button type="button" className="btn btn-light">Light</button>
            <button type="button" className="btn btn-dark">Dark</button>
          </div>
          <div className="d-flex justify-content-between mt-1">
            <button type="button" className="btn btn-outline-primary">Primary</button>
            <button type="button" className="btn btn-outline-secondary">Secondary</button>
            <button type="button" className="btn btn-outline-success">Success</button>
            <button type="button" className="btn btn-outline-danger">Danger</button>
            <button type="button" className="btn btn-outline-warning">Warning</button>
            <button type="button" className="btn btn-outline-info">Info</button>
            <button type="button" className="btn btn-outline-light">Light</button>
            <button type="button" className="btn btn-outline-dark">Dark</button>
          </div>
        </div>
        <div className="mt-2">
          <h2>Tabs</h2>
          <div>
            <div className="btn-group" role="group" aria-label="Basic example">
              <button type="button" className="btn btn-primary">Month</button>
              <button type="button" className="btn btn-outline-light">Week</button>
              <button type="button" className="btn btn-outline-light">Day</button>
            </div>
            <div className="btn-group btn-group-lg ml-1" role="group" aria-label="Basic example">
              <button type="button" className="btn btn-outline-light">Description</button>
              <button type="button" className="btn btn-primary">Contact info</button>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <h2>Cards</h2>
          <div className="row">
            <div className="col-6">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Special title treatment</h4>
                  <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                  <a href="#" className="btn btn-primary">Go somewhere</a>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="card">
                <div className="card-header card-header--with-action">
                  <h4>Your Order</h4>
                  <div className="btn-group btn-group-xs" role="group" aria-label="Basic example">
                    <button type="button" className="btn btn-primary">Month</button>
                    <button type="button" className="btn btn-outline-light">One-off</button>
                  </div>
                </div>
                <div className="card-body">
                  <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                  <a href="#" className="btn btn-primary">Go somewhere</a>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <div className="card">
                <div className="card-header card-header--with-action">
                  <h4>Featured</h4>
                  <a href="#">See more</a>
                </div>
                <div className="card-body">
                  <h4 className="card-title">Special title treatment</h4>
                  <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                  <a href="#" className="btn btn-primary">Go somewhere</a>
                </div>
                <div className="card-header card-header--with-action">
                  <h4>Featured</h4>
                  <a href="#">See more</a>
                </div>
                <div className="card-body">
                  <h4 className="card-title">Special title treatment</h4>
                  <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                  <a href="#" className="btn btn-primary">Go somewhere</a>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="card">
                <div className="card-header">
                  <h4>Much longer title to see the bottom line</h4>
                </div>
                <div className="card-body">
                  <h4 className="card-title">Special title treatment</h4>
                  <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                  <a href="#" className="btn btn-primary">Go somewhere</a>
                </div>
                <div className="card-footer card-footer--with-action">
                  <a href="#">Previous step</a>
                  <button type="button" className="btn btn-primary">Next step</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <h2>Forms</h2>
          <form>
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Email address</label>
              <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
              <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1">Password</label>
              <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Password" />
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <input type="checkbox" className="form-check-input" />
                Check me out
              </label>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/StyleGuide.jsx